var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "./FormElement", "jquery", "jquery"], function (require, exports, FormElement_1, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.checkSelectFieldsValidity = exports.checkFormValidity = exports.handleFormInvalidation = exports.setValidDecoration = exports.setInvalidDecoration = exports.isValidSelectField = exports.isValidInputUnit = exports.isValidDatepicker = exports.handleFormElementValidation = exports.isValid = void 0;
    FormElement_1 = __importDefault(FormElement_1);
    var formElementFieldValidClass = "formElement_field--is-valid";
    var formElementErrorMessageSelector = ".formElement_errorMessage";
    /**
     * Prüft, ob ein Eingabefeld gültig ist
     * @param {HTMLInputElement} field - Das zu prüfende Eingabefeld
     * @returns {boolean} True, wenn das Feld gültig ist
     */
    function isValid(field) {
        var $field = $(field);
        var isValid;
        if (FormElement_1.default.isUnitField($field)) {
            isValid = isValidInputUnit($field);
        }
        else if (FormElement_1.default.isSelectTag($field)) {
            isValid = isValidSelectField($field);
        }
        else if (FormElement_1.default.isDatepickerInput($field)) {
            isValid = isValidDatepicker($field);
        }
        else {
            isValid = field.validity.valid;
        }
        return isValid;
    }
    exports.isValid = isValid;
    /**
     * Validiert FormElement-Felder und aktualisiert deren visuelle Darstellung
     * @param {JQuery} $formElementFields - Die zu validierenden FormElement-Felder
     */
    function handleFormElementValidation($formElementFields) {
        $formElementFields.each(function (index, formElementField) {
            var _a;
            var $formElementField = $(formElementField);
            var $formElementValidateField = $formElementField.parents(FormElement_1.default.formElementValidateSelector);
            var $errorMessageField = $formElementValidateField.find(formElementErrorMessageSelector);
            var errorMessage;
            var firstField = $formElementField.find(FormElement_1.default.inputFieldSelector).get(0);
            if (firstField.type === "hidden" && $formElementField.hasClass("formElement_field-checkbox")) {
                firstField = $formElementField.find(FormElement_1.default.inputFieldSelector).get(1);
            }
            firstField.setCustomValidity("");
            if (isValid(firstField)) {
                setValidDecoration($formElementField);
                setValidDecoration($formElementValidateField);
                errorMessage = "";
                $errorMessageField.text(errorMessage);
                $formElementValidateField.css("margin-bottom", "1.25rem");
                firstField.setAttribute("aria-invalid", "false");
            }
            else {
                setInvalidDecoration($formElementField);
                setInvalidDecoration($formElementValidateField);
                errorMessage = $(firstField).data("error-message");
                firstField.setCustomValidity(errorMessage);
                $errorMessageField.text(errorMessage);
                firstField.setAttribute("aria-invalid", "true");
                var errorMessageFieldHeight = (_a = $errorMessageField.innerHeight()) !== null && _a !== void 0 ? _a : 0;
                $formElementValidateField.css("margin-bottom", 2.5 + errorMessageFieldHeight / 16 + "rem");
            }
        });
    }
    exports.handleFormElementValidation = handleFormElementValidation;
    /**
     * Prüft, ob ein Datepicker-Feld gültig ist
     * @param {JQuery<HTMLInputElement>} $field - Das zu prüfende Datepicker-Feld
     * @returns {boolean} True, wenn das Datum innerhalb des gültigen Bereichs liegt
     */
    function isValidDatepicker($field) {
        var minAttribute = $field.attr("min") || "0000-01-01";
        var maxAttribute = $field.attr("max") || "9999-12-31";
        var currentDatetime = FormElement_1.default.convertStringToDate($field.val()).getTime();
        var minDatetime = FormElement_1.default.convertStringToDate(minAttribute).getTime();
        var maxDatetime = FormElement_1.default.convertStringToDate(maxAttribute).getTime();
        return minDatetime <= currentDatetime && currentDatetime <= maxDatetime;
    }
    exports.isValidDatepicker = isValidDatepicker;
    /**
     * Prüft, ob ein Einheitenfeld gültig ist
     * @param {JQuery<HTMLInputElement>} $inputUnitField - Das zu prüfende Einheitenfeld
     * @returns {boolean} True, wenn der Wert innerhalb des gültigen Bereichs liegt
     */
    function isValidInputUnit($inputUnitField) {
        var isRequired = $inputUnitField.prop("required") === true;
        if (!$inputUnitField.val()) {
            return !isRequired;
        }
        var minValue = parseInt($inputUnitField.attr("min"), 10);
        var maxValue = parseInt($inputUnitField.attr("max"), 10);
        if (!minValue) {
            minValue = -Number.MAX_VALUE;
        }
        if (!maxValue) {
            maxValue = Number.MAX_VALUE;
        }
        var value = parseInt(FormElement_1.default.formatInputFieldValue($inputUnitField.val()), 10);
        return minValue <= value && maxValue >= value;
    }
    exports.isValidInputUnit = isValidInputUnit;
    /**
     * Prüft, ob ein Select-Feld gültig ist
     * @param {JQuery} $field - Das zu prüfende Select-Feld
     * @returns {boolean} True, wenn ein Wert ausgewählt wurde
     */
    function isValidSelectField($field) {
        return $field.val() !== "-";
    }
    exports.isValidSelectField = isValidSelectField;
    /**
     * Markiert ein Element als ungültig
     * @param {JQuery} $element - Das zu markierende Element
     */
    function setInvalidDecoration($element) {
        $element.addClass(FormElement_1.default.formElementFieldInvalidClass);
        $element.removeClass(formElementFieldValidClass);
    }
    exports.setInvalidDecoration = setInvalidDecoration;
    /**
     * Markiert ein Element als gültig
     * @param {JQuery} $element - Das zu markierende Element
     */
    function setValidDecoration($element) {
        $element.removeClass(FormElement_1.default.formElementFieldInvalidClass);
        $element.addClass(formElementFieldValidClass);
    }
    exports.setValidDecoration = setValidDecoration;
    /**
     * Fügt Validierungshandler zu einem Formular hinzu
     * @param {HTMLFormElement} form - Das zu konfigurierende Formular
     */
    function handleFormInvalidation(form) {
        var $form = $(form);
        form.addEventListener("invalid", function (event) {
            $form.find("select").trigger("change");
            handleFormElementValidation(FormElement_1.default.getFormElementField($(event.target)));
            event.preventDefault();
        }, true);
        $form.on("submit", function (event) {
            if (!checkFormValidity($form)) {
                handleFormElementValidation($form.find(FormElement_1.default.formElementFieldSelector));
                FormElement_1.default.scrollToFirstInvalidFormElement($form);
                event.preventDefault();
            }
        });
        $form.on("validate", function (event) {
            event.preventDefault();
            var formFirst = $form.get(0) || null;
            if (formFirst !== null) {
                if (checkFormValidity($form)) {
                    formFirst.setAttribute("isValid", "true");
                }
                else {
                    handleFormElementValidation($form.find(FormElement_1.default.formElementFieldSelector));
                    formFirst.setAttribute("isValid", "false");
                    FormElement_1.default.scrollToFirstInvalidFormElement($form);
                }
            }
        });
    }
    exports.handleFormInvalidation = handleFormInvalidation;
    /**
     * Prüft die Gültigkeit eines Formulars
     * @param {JQuery} $form - Das zu prüfende Formular
     * @returns {boolean} True, wenn das Formular gültig ist
     */
    function checkFormValidity($form) {
        return $form.get(0).checkValidity() && checkSelectFieldsValidity($form);
    }
    exports.checkFormValidity = checkFormValidity;
    /**
     * Prüft die Gültigkeit aller Select-Felder in einem Formular
     * @param {JQuery} $form - Das zu prüfende Formular
     * @returns {boolean} True, wenn alle Select-Felder gültig sind
     */
    function checkSelectFieldsValidity($form) {
        var $selectFields = $form.find("select");
        var numberOfValidSelectFields = $selectFields.filter(function (index, selectField) {
            return isValidSelectField($(selectField));
        }).length;
        return $selectFields.length === numberOfValidSelectFields;
    }
    exports.checkSelectFieldsValidity = checkSelectFieldsValidity;
});
